import { NotStepInstance } from '../errors';

import Step from './Step';

class PendingStep extends Step {
  constructor(step) {
    if (!(step instanceof Step)) {
      throw new NotStepInstance(`${step} is not instance of ${Step}`);
    }

    super(step.name, step.completedURL, step.pendingURL);
  }

  get url() {
    return this._pendingURL;
  }
}

export default PendingStep;
